
export default {
  name: "VerifyEmailOk",
};
